import React from "react";
import { useEffect, useState } from "react";
import AOS from "aos";

const ScrollTop = () => {
  const [scrollTop, setscrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1300 });
    window.addEventListener("scroll", () => {
      if (window.scrollY > 250) {
        setscrollTop(!scrollTop);
      } else {
        setscrollTop(!scrollTop);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollUp = () => {
    window.scrollTo({ top: 0, behaviour: "smooth" });
  };

  return (
    <div>
      {scrollTop && (
        <button
          data-aos="fade-up"
          style={{
            position: "fixed",
            bottom: "1rem",
            right: "1rem",
            height: "2.8rem",
            width: "2.7rem",
            fontSize: "2.12rem",
            border: "none",
            outline: "none",
            backgroundColor: "rgb(40, 182, 114)",
            color: "white",
            cursor: "pointer",
            borderRadius: "50%",
            "&:hover": {
              backgroundColor: "#efefef",
            },
          }}
          onClick={scrollUp}
        >
          ^
        </button>
      )}
    </div>
  );
};

export default ScrollTop;
